import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PeopleIcon = _resolveComponent("PeopleIcon")!
  const _component_ArchiveIcon = _resolveComponent("ArchiveIcon")!
  const _component_AlbumIcon = _resolveComponent("AlbumIcon")!
  const _component_MapIcon = _resolveComponent("MapIcon")!
  const _component_ImageMultipleIcon = _resolveComponent("ImageMultipleIcon")!
  const _component_NcEmptyContent = _resolveComponent("NcEmptyContent")!

  return (_openBlock(), _createBlock(_component_NcEmptyContent, {
    name: _ctx.t('memories', 'Nothing to show here'),
    description: _ctx.emptyViewDescription
  }, {
    icon: _withCtx(() => [
      (_ctx.routeIsPeople)
        ? (_openBlock(), _createBlock(_component_PeopleIcon, { key: 0 }))
        : (_ctx.routeIsArchive)
          ? (_openBlock(), _createBlock(_component_ArchiveIcon, { key: 1 }))
          : (_ctx.routeIsAlbums)
            ? (_openBlock(), _createBlock(_component_AlbumIcon, { key: 2 }))
            : (_ctx.routeIsMap)
              ? (_openBlock(), _createBlock(_component_MapIcon, { key: 3 }))
              : (_openBlock(), _createBlock(_component_ImageMultipleIcon, { key: 4 }))
    ]),
    _: 1
  }, 8, ["name", "description"]))
}